import "@features/summary/css/summaryPage.scss";
import { Payment } from "@features/summary/Payment";
import { Box } from "@mui/material";
import { FlyingCart } from "@features/cart/components/FlyingCart";
import { IFlyingCart } from "@features/cart/IFlyingCart";
import { ICart } from "@features/cart/ICart";
import { useDeviceType } from "@hooks/useDeviceType";
import { OrderSummaryMobile } from "@features/cart/components/FlyingCart/FlyingCartLayouts/OrderSummaryMobile";
import { useStyle } from "./style";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

interface IParams {
    cart: ICart;
    flyingCart: IFlyingCart;
}

export const SummaryPage = (props: IParams) => {
    const { cart, flyingCart } = props;
    const { isMobile, isTabletOrDesktop } = useDeviceType();
    const { classes } = useStyle();
    const { t } = useTranslation("summary");

    return (
        <div className={classes.containerBoxed}>
            <Helmet>
                <meta content={t("title")} property="og:title" />
                <meta content="noindex, nofollow" name="robots" />
                <title>{t("title")}</title>
            </Helmet>
            <Box display="flex" flexDirection={isMobile ? "column" : "row"} gap={4}>
                {isMobile && <OrderSummaryMobile flyingCart={flyingCart} />}
                <Box maxWidth={isMobile ? "100%" : 700} width="100%">
                    <Payment cart={cart} />
                </Box>
                {isTabletOrDesktop && <FlyingCart flyingCart={flyingCart} isSummaryPage />}
            </Box>
        </div>
    );
};
